import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import LoginHeader from './LoginHeader';
import LoginForm from './LoginForm';
import AddToHome from './AddToHome';

const Login = ({ className, location }) => {
    const isLogin = useSelector(state => state.auth.isLogin);

    return isLogin ? (
        <Redirect
            to={{
                pathname: '/dashboard',
                state: { from: location }
            }}
        />
    ) : (
        <div className={className}>
            <LoginHeader />
            <LoginForm />
            {/* <AddToHome /> */}
        </div>
    );
};

Login.propTypes = {
    className: PropTypes.string.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired
    }).isRequired
};

export default styled(Login)`
    ${LoginHeader} {
        width: 100%;
    }

    ${LoginForm} {
        width: 100%;
    }
`;
